import { jsx as _jsx } from "react/jsx-runtime";
import { WmTabList, WmTabItem } from "@watermarkinsights/ripple-react";
export default function TabComponent(props) {
    return (_jsx(WmTabList, { id: "tab-with-controller", selectedTab: props.selectedTab, onWmTabSelected: props.onWmTabSelected, children: props.tabOption.map(function (tab, index) { return (_jsx(WmTabItem, { tabId: "item-" + (index + 1), children: tab.name }, tab.id)); }) }));
}
